import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'components/base';

import { Button, Typography } from '../components/base';
import Icon, { ICON_TYPE } from '../components/base/icon';
import PageThumb from '../components/page/thumb';
import { Modal } from '../components/rich';
import { generatePage } from '../generator/utils';
import { getOriginalPage, getTemplatePage, isTOCPage } from 'editor-utils/template';

const PageSelectorContext = createContext();

export const PageSelectorContextProvider = props => {
  const [isVisible, setIsVisible] = useState(false);

  const [params, setParams] = useState({});

  const show = (template, config = {}) => {
    // TODO
    // blank pageId has higher priority
    const blankPage = getTemplatePage(template, 'blank');
    if (blankPage) {
      if (config.onSelect) {
        config.onSelect(generatePage(blankPage, { pageNumber: config.pageNumber }));
      }
      return;
    }

    setIsVisible(true);
    setParams({ template, config });
  };

  const hide = () => {
    setIsVisible(false);
    setParams({});
  };

  const handleOnSelectPage = async page => {
    if (params?.config?.onSelect) {
      await params.config.onSelect(generatePage(page, { pageNumber: params.config.pageNumber }));
    }
    hide();
  };

  return (
    <PageSelectorContext.Provider
      value={{
        show,
        hide,
      }}
    >
      {props.children}

      {isVisible && (
        <Modal size="large" position="start" visible>
          <Modal.Header>
            <Typography.Heading size={3}>{params.config.title || 'Select Page'}</Typography.Heading>
            <Button variant="secondary" onClick={hide}>
              <Icon type={ICON_TYPE.CLOSE} width={18} height={18} mr={0} /> Close
            </Button>
          </Modal.Header>
          <Modal.Body>
            <Grid.Row>
              {params.template.pages
                .filter(page => !isTOCPage(params.template, page.id))
                .map(page => (
                  <Grid.Col key={page.id} xs={12} sm={6} md={4} xl={3} className="my-1">
                    <PageThumb
                      page={getOriginalPage(params.template, generatePage(page))}
                      template={params.template}
                      onClick={() => handleOnSelectPage(page)}
                    />
                  </Grid.Col>
                ))}
            </Grid.Row>
          </Modal.Body>
        </Modal>
      )}
    </PageSelectorContext.Provider>
  );
};

PageSelectorContextProvider.propTypes = {
  children: PropTypes.node,
};

const usePageSelectorContext = () => {
  return useContext(PageSelectorContext);
};

export default usePageSelectorContext;
